import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { StudentResponse } from "../../models/dtos";


export const facultyNumberTemplate = (rowData: StudentResponse) => {
  return (
    <div className="flex align-items-center">
      <Link to={`/students/${rowData.studentId}`}>
        <Button outlined>{rowData.facultyNumber}</Button>
      </Link>
    </div>
  );
};
